import React from 'react';
import { connect } from 'react-redux'
import { setQuestionAnswer, removeQuestionAnswer } from '../../api/health-questions/actions'
import { setInfoKey } from '../../api/information-collection/actions';
import { getFundTable } from '../../api/fund-table/actions'
import { SvgArrowIcon, SvgCheckIcon } from '../svg';
import VIDPercentage from '../vid-percentage'
import VIDTermination from '../vid-termination'
import { getContractStartDate } from '../../utils';
import moment from 'moment'

// This module is used for both VID and VIDT

class VIDTmodule extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            // "VIDTformerFund": "000",
            // "VIDTallianzOwnContribution": "4.0",
            // "VIDTallianzEmployerContribution": "",
            // "VIDTotherFund": "000",
            // "VIDTotherOwnContribution": "0.0",
            // "VIDTotherEmployerContribution": "",
            // "VIDTfundTransfer": false,

        }
        this.onChange = this.onChange.bind(this);
        this.getFunds = this.getFunds.bind(this)
        // this.getFieldValue = this.getFieldValue.bind(this)
        // this.clearSection = this.clearSection.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.validateButtonDisplay = this.validateButtonDisplay.bind(this)

        this.addToContract = this.addToContract.bind(this)
    }

    componentDidMount() {
        let { type } = this.props; // VID or VIDT
        this.props.dispatch(getFundTable());

        // Create variable names for references
        this.setState({
            ...this.state,
            FF: type+"formerFund",
            FT: type+"fundTransfer",
            FTT: type+"fundTerminate",
            OF: type+"otherFund",
            AOC: type+"allianzOwnContribution",
            AEC: type+"allianzEmployerContribution",
            OOC: type+"otherOwnContribution",
            OEC: type+"otherEmployerContribution",
        })
    }

    componentWillUnmount() {
        let { type } = this.props; // VID or VIDT
        // If there is a termination or percentage split, add 2 months to VID start date
        if (this.state[type + "formerFund"] !== "000" || (this.state[type + "otherFund"] && this.state[type + "otherFund"] !== "000")) {
            let oldDate = getContractStartDate("VIDT")
            let newDate = oldDate.add(2, 'months')
            this.props.dispatch(setInfoKey({ key: type + "contractstartdate", value: newDate.format("D.M.YYYY") }, this.props.customerId))
        }
    }

    addToContract(key, value, contractId = 0) {
        this.setState({ [key]: value })
    }

    dispatchHelp(key, value, infoType){
        let { type, customerId } = this.props;
        let groupTitle = type;
        let insuranceName = type;
        this.props.dispatch(setQuestionAnswer({ key: key, value: value }, customerId, insuranceName, infoType, groupTitle))
    }

    onChange(e, infoType, id) {
        const { name, value } = e.currentTarget;
        let { type, fundTable } = this.props;
        let { FF, FT, FTT, OF, AOC, AEC, OOC, OEC } = this.state;
        let groupTitle = type;
        let insuranceName = type;

        if (name === FF || name === OF) {
            let fund = fundTable.data.FundTable.FundLine.find((fund) => fund.FundId === value)
            let fundName = fund.Name;
            this.dispatchHelp(name + "Name", fundName, infoType)
        }

        if (name === FF && !this.props.healthQuestions.groups[this.props.customerId][insuranceName][groupTitle]["termination"][FT]) {
            this.dispatchHelp(FT, false, infoType)
        }

        // If dropdown is kept as default, we set it when adding Employer Contribution
        if (name == AEC) {
            this.dispatchHelp(name, value, infoType)
            this.dispatchHelp(AOC, this.state[AOC], infoType)
            this.setState({ [name]: value })
        } else if (name == OEC) {
            this.dispatchHelp(name, value, infoType)
            this.dispatchHelp(OOC, this.state[OOC], infoType)
            this.setState({ [name]: value })
        } else {
            this.dispatchHelp(name, value, infoType)
            this.setState({ [name]: value })
        }
    }

    onCheckboxChange(e, infoType) {
        const { name, checked } = e.target;
        this.dispatchHelp(name, checked, infoType)
        this.setState({ [name]: checked })
    }

    getFundValue(formerFund, healthQuestions, customerId) {
        let { type } = this.props;
        let { FF, FT, OF, AOC, AEC, OOC, OEC } = this.state;
        let fundValue = ""
        if (formerFund) {
            if (healthQuestions.data[customerId] && healthQuestions.data[customerId][type] && healthQuestions.data[customerId][type][FF]) {
                fundValue = healthQuestions.data[customerId][type][FF]
            } else {
                fundValue = this.state[FF]
            }
        } else {
            if (healthQuestions.data[customerId] && healthQuestions.data[customerId][type] && healthQuestions.data[customerId][type][OF]) {
                fundValue = healthQuestions.data[customerId][type][OF]
            } else {
                fundValue = this.state[OF]
            }
        }
        return fundValue
    }

    // getFieldValue(fieldName, customerId) {
    //     let healthQuestions = this.props.healthQuestions;
    //     let { type } = this.props;
    //     let fieldValue = "";
    //     if (healthQuestions.data[customerId] && healthQuestions.data[customerId][type] && healthQuestions.data[customerId][type][fieldName]) {
    //         fieldValue = healthQuestions.data[customerId][type][fieldName];
    //     } else {
    //         fieldValue = this.state[fieldName]
    //     }
    //     return fieldValue;
    // }

    getFunds(customerId, bla, formerFund, infoType) {
        let { fundTable, type } = this.props;
        let healthQuestions = this.props.healthQuestions;
        let allFunds = <select className="custom-select col-12 col-sm-6" id={formerFund ? `vidt-former-fund-${customerId}` : `vidt-other-fund-${customerId}`} name={formerFund ? type + "formerFund" : type + "otherFund"} value={this.getFundValue(formerFund, healthQuestions, customerId)} onChange={(e) => this.onChange(e, infoType, fundTable)} >
            {fundTable.data && !fundTable.isFetching && fundTable.data.FundTable.FundLine.map((fund) => {
                return (<option value={fund.FundId}>{fund.Name}</option>)
            })}
        </select>
        return allFunds
    }

    validateButtonDisplay(infoType) {
        let healthQuestions = this.props.healthQuestions
        let { FF, FT, OF, AOC, AEC, OOC, OEC } = this.state;
        let { type } = this.props;
        if (infoType === "split-percentage" && healthQuestions.data[this.props.customerId]
            && healthQuestions.data[this.props.customerId][type]
            && healthQuestions.data[this.props.customerId][type][AOC]
            && healthQuestions.data[this.props.customerId][type][AEC]
            && healthQuestions.data[this.props.customerId][type][OF]
            && healthQuestions.data[this.props.customerId][type][OOC]
            && healthQuestions.data[this.props.customerId][type][OEC]) {
            return true
        }
        if (infoType === "termination" && healthQuestions.data[this.props.customerId]
            && healthQuestions.data[this.props.customerId][type]
            && healthQuestions.data[this.props.customerId][type][FF]) {
            return true
        }
        return false
    }

    render() {
        const { offerQueryParams, customerId, fundTable, healthQuestions, type, title } = this.props;
        let { FF, FT, OF, AOC, AEC, OOC, OEC } = this.state;

        if ((offerQueryParams[type] && offerQueryParams[type] === true) || (offerQueryParams[type+"E"] && offerQueryParams[type+"E"] === true)) {
            return (
                <div className="vidt-module row">
                    <div className="p-0 col-12" id="accordion">
                        {(this.validateButtonDisplay("split-percentage", healthQuestions) && this.validateButtonDisplay("termination", healthQuestions)) ? (<span className="check"><span className="check check-icon big green">
                            <SvgCheckIcon />
                        </span></span>) : (<span></span>)}
                        <p className="content-title group-heading collapsed" data-toggle="collapse" href={"#" + type + "addition-" + customerId} role="button" aria-expanded="false" aria-controls={type + "addition-" + this.props.customerId}>
                            { title }
                            <span className="arrow-toggle-button">
                                <SvgArrowIcon />
                            </span>
                        </p>
                        <div className="collapse" id={type + "addition-" + customerId}>
                            <div className="accordion">
                                <VIDTermination
                                    customerId={customerId}
                                    fundTable={fundTable}
                                    onCheckboxChange={this.onCheckboxChange}
                                    onChange={this.onChange}
                                    values={this.state}
                                    addToContract={this.addToContract}
                                    type={type}
                                    />
                            </div>
                            { type == "VID" && 
                                <div className="accordion">
                                    <VIDPercentage 
                                        customerId={customerId} 
                                        fundTable={fundTable} 
                                        VIDallianzOwnContribution={this.state[AOC]} 
                                        VIDotherOwnContribution={this.state[OOC]} 
                                        validateButtonDisplay={this.validateButtonDisplay} 
                                        getFunds={this.getFunds} 
                                        onChange={this.onChange}
                                        addToContract={this.addToContract}
                                        type={type}
                                        values={this.state}
                                        />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            )
        }
    }
}

VIDTmodule.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        healthQuestions: {},
        fundTable: {},
        infoCollection: {},
        offers: {}
    }

    f.healthQuestions = (state.healthQuestions === undefined) ? {} : state.healthQuestions
    f.fundTable = (state.fundTable === undefined) ? {} : state.fundTable
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.offers = (state.offers === undefined) ? {} : state.offers

    return f;
}

export default connect(mapStateToProps)(VIDTmodule);